import Vue from 'vue'
import App from './App.vue'

import VueRouter from "vue-router";
import routerConfig from './router.config'
import store from './store/index.js'
import { message } from 'ant-design-vue'
import 'moment/locale/zh-cn';

Vue.config.productionTip = false


Vue.use(VueRouter)
const router = new VueRouter(routerConfig)


Vue.prototype.$message = message;
message.config({
  duration: 2,// 持续时间
  top:`100px`, // 到页面顶部距离
  maxCount: 3 // 最大显示数, 超过限制时，最早的消息会被自动关闭
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
